// ScrollToTop.jsx - Back-to-top button component with smooth scrolling animation

import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = () => {
    // Track visibility state based on scroll position
    const [isVisible, setIsVisible] = useState(false);

    // Set up scroll event listener to show/hide button
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    // Handle scroll to top action
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Render back-to-top button with animations when visible
    const renderBackToTopButton = () => (
        <motion.button
            initial={{ opacity: 0, scale: 0, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0, y: 20 }}
            whileHover={{
                scale: 1.1,
                backgroundColor: 'rgba(235, 0, 135, 0.9)'
            }}
            whileTap={{ scale: 0.9 }}
            onClick={handleScrollToTop}
            className="fixed bottom-8 right-8 z-50 p-4 rounded-full bg-gradient-to-br from-primary to-secondary text-white shadow-2xl hover-glow glass-effect border border-white/20 flex items-center justify-center"
            aria-label="Go back to top of page"
            style={{ width: '56px', height: '56px' }}
        >
            <motion.div
                animate={{
                    y: [0, -2, 0]
                }}
                transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
            >
                <ChevronUp size={24} />
            </motion.div>
        </motion.button>
    );

    return (
        <AnimatePresence>
            {isVisible && renderBackToTopButton()}
        </AnimatePresence>
    );
};

export default ScrollToTop;
